import { useQuery } from "@apollo/client";
import { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";
import { Person } from "@/types";
import { usePersonContactAccess } from "./_usePersonContactAccess";
import { PERSON_CONTACT_MEMBERSHIP_QUERY, PERSON_DETAILS_QUERY } from "./queries";

type PersonData = { person: Person };

export function usePersonContactDetailsQuery(pgaId?: string) {
  const { loaded, canViewPersonContact } = usePersonContactAccess();
  const canViewPersonMembership = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonMembership
  });

  const skip = !loaded || !canViewPersonContact || !pgaId;
  const { data, error } = useQuery<PersonData>(PERSON_DETAILS_QUERY, {
    variables: { pgaId },
    fetchPolicy: "cache-first",
    skip
  });
  const { data: membershipData, loading: membershipLoading } = useQuery(PERSON_CONTACT_MEMBERSHIP_QUERY, {
    variables: { pgaId: pgaId ?? "" },
    skip: skip || !canViewPersonMembership,
    fetchPolicy: "network-only"
  });

  const membershipReady = !canViewPersonMembership || !membershipLoading;
  const person =
    data?.person && membershipReady
      ? membershipData?.person
        ? { ...data.person, latestProgram: membershipData.person.latestProgram }
        : data.person
      : undefined;

  return { loaded, canViewPersonContact, person, error };
}
